import { ICannabisFormData } from 'Modules/Reimbursements/Cannabis/CannabisMain';
import { getCleanFileName } from './files';

export const reimbursementsFormPrepareData = (
  requestsData: ICannabisFormData
) => {
  // Build form data object before submit
  const formData = new FormData();
  formData.append('note', requestsData.additionalDetails || '');
  formData.append('phoneNumber', requestsData.phone.number || '');
  formData.append('phonePrefixId', requestsData.phone.prefix?.toString() || '');
  formData.append('shikumSubTypeId', requestsData.type.toString());

  requestsData.invoices.forEach((field, index) => {
    if (!field.file) return;

    formData.append(
      `fieldAttachmentsData[${index}].fieldId`,
      requestsData.fieldId
    );
    const renamedFile = new File(
      [field.file],
      getCleanFileName(field.file.name),
      {
        type: field.file.type,
      }
    );
    formData.append(`fieldAttachmentsData[${index}].attachments`, renamedFile);
    const invoicesJson = {
      isApproved: requestsData.isApproved,
      invoicesDetails: requestsData.invoices.map((invoice) => ({
        invoiceNumber: invoice.invoiceId,
        invoiceDate: invoice.invoiceDate,
        invoiceAmount: invoice.invoiceTotal,
      })),
    };
    formData.append('requestDataJson', JSON.stringify(invoicesJson));
  });

  return formData;
};

export const filterAndLimitInput = (
  e: React.ChangeEvent<HTMLInputElement>,
  maxInvoiceLength: number
) => {
  const value = e.target.value;
  const filteredValue = value
    .replace(/[a-zA-Zא-ת]/g, '')
    .slice(0, maxInvoiceLength);
  e.target.value = filteredValue;
  return filteredValue;
};
